import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import herings_logo_b from "../../assets/images/etc/heringsLOGO_black.svg";
import blogsvg from "../../assets/images/etc/blog.svg";
import kakaosvg from "../../assets/images/etc/kakao.svg";
import youtubesvg from "../../assets/images/etc/youtube.svg";
import instagramsvg from "../../assets/images/etc/instagramsvg.svg";
import { DEFAULT_LANG } from "../../i18n";
import "./FooterV2.css";

const getLangFromPath = (pathname) => {
  const m = pathname.match(/^\/(kr|en)(\/|$)/);
  return m ? m[1] : DEFAULT_LANG;
};

export default function FooterV2() {
  const { t } = useTranslation();
  const history = useHistory();
  const lang = getLangFromPath(useLocation().pathname);
  const go = (p) => history.push(`/${lang}${p}`);

  const columns = [
    {
      title: t("homeV2.footer.company"),
      links: [
        { label: t("homeV2.nav.about"), to: "/whoweare/" },
        { label: t("menu.sub.heringsteam"), to: "/heringsteam/" },
        { label: t("menu.sub.ir"), to: "/irinformation/" },
        { label: t("homeV2.nav.news"), to: "/news/" },
      ],
    },
    {
      title: t("homeV2.nav.solutions"),
      links: [
        { label: t("menu.sub.rpm"), to: "/rpmsolution/" },
        { label: t("menu.sub.healthcare"), to: "/healthcare/" },
        { label: t("menu.sub.clinicalresearch"), to: "/clinicalresearch/" },
      ],
    },
  ];

  const socials = [
    { src: blogsvg, alt: "blog", href: "https://blog.naver.com/healiary" },
    { src: kakaosvg, alt: "kakao", href: "https://pf.kakao.com/_xlPYExj" },
    { src: youtubesvg, alt: "youtube", href: "https://www.youtube.com/@healiary" },
    { src: instagramsvg, alt: "instagram", href: "https://www.instagram.com/healiary_official/" },
  ];

  return (
    <footer className="v2foot">
      <div className="v2foot-top">
        <div className="v2foot-brand">
          <img src={herings_logo_b} alt="HERINGS" className="v2foot-logo" />
          <p className="v2foot-tagline">{t("homeV2.footer.tagline")}</p>
          <div className="v2foot-socials">
            {socials.map((s) => (
              <a key={s.alt} href={s.href} target="_blank" rel="noopener noreferrer">
                <img src={s.src} alt={s.alt} />
              </a>
            ))}
          </div>
        </div>

        <div className="v2foot-cols">
          {columns.map((col) => (
            <div className="v2foot-col" key={col.title}>
              <p className="v2foot-col-title">{col.title}</p>
              {col.links.map((l) => (
                <button key={l.label} className="v2foot-col-link" onClick={() => go(l.to)}>
                  {l.label}
                </button>
              ))}
            </div>
          ))}
          <div className="v2foot-col">
            <p className="v2foot-col-title">{t("homeV2.nav.contact")}</p>
            <p className="v2foot-meta">{t("footer.address")}</p>
            <p className="v2foot-meta">herings@heringsglobal.com</p>
            <p className="v2foot-meta">{t("footer.registration")}</p>
          </div>
        </div>
      </div>

      <div className="v2foot-bottom">
        <span>{t("footer.copyright", { year: new Date().getFullYear() })}</span>
        <div className="v2foot-legal">
          <button onClick={() => go("/privacypolicy/healiary/0")}>{t("footer.privacy")}</button>
          <span className="v2foot-dot">·</span>
          <button onClick={() => go("/privacypolicy/healiary/1")}>{t("footer.terms")}</button>
        </div>
      </div>
    </footer>
  );
}
